import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// import './SearchBar.css';

const SearchBar = ({ apiBaseUrl }) => {
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!query) {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }
    fetch(`${apiBaseUrl}/search_suggestions?q=${encodeURIComponent(query)}`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => {
        setSuggestions(data);
        setShowSuggestions(data.length > 0);
      })
      .catch(err => console.error('Error fetching suggestions:', err));
  }, [query, apiBaseUrl]);

  const typeIcons = {
    SteamGame: '/static/icons/steam.svg',
    Anime: '/static/icons/clapperboard-solid.svg',
    Manga: '/static/icons/book-solid.svg',
    PhysicalGame: '/static/icons/gamepad-solid.svg',
    Music: '/static/icons/compact-disc-solid.svg',
    ScreenMedia: '/static/icons/film-solid.svg',

  };

  return (
    <div className="search-section">
      <h2>Quick Search</h2>
      <div className="search-input-wrapper">
        <input
          type="text"
          id="global-search"
          placeholder="Search across all media..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <img src="/static/icons/magnifying-glass-solid.svg" className="search-icon icon" alt="Search" />
        {showSuggestions && (
          <div className="search-suggestions">
            {suggestions.map((item) => (
              <a
                key={`${item.type}-${item.title}`}
                // href={`/media-list/${item.type}#search=${encodeURIComponent(item.title)}`}
                href={`/media-item/${item.id}`}
                className="suggestion-item"
              >
                <img src={item.image || '/static/placeholder.jpg'} className="suggestion-thumb" alt={item.title} />
                <img src={typeIcons[item.type] || '/static/icons/question-solid.svg'} className="type-icon" alt={item.type} />
                {item.title}
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchBar;